
import { Edit } from '@mui/icons-material';
import { Button, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import DialogModifierDossier from '../../../Components/Dialogs/DialogModifierDossier';
import { buttonStylesGreen } from '../../../Components/docsAdministrative/JsObjectStyles';
import { MaterialTableComponent } from '../../../Components/shared/ReusableSmallComponents';
import { StatutDosier } from '../../../data/Interfaces';
import useGetRequest from '../../../hooks/useGetRequest';
import { useNumberFormatting } from '../../../hooks/useNumberFormatting';
import usePostRequest from '../../../hooks/usePostRequest';
import useRole from '../../../hooks/useRole';
import useWindowSize from '../../../hooks/useWindowSize';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import { getNomPrenomClearFromPersoData, searchLabelInEnumByValue } from '../../../Utils/utils';
import { countCandidatureByStatus } from '../../Admin/AOs/AllAOs';

const AllMyDossier = () => {
    const { addEuro4Decimal } = useNumberFormatting();
    const { i18n } = useTranslation();
    const role=useRole();
    const columns = [
        {
            field: 'eye',
            title: i18n.t('Option'),
            render: rowData => {
                return (
                    <IconButton
                        onClick={() => {
                            setSelectedDossier(rowData);
                            setOpenClasser(true);
                        }}
                    >
                        <Edit />
                    </IconButton>
                );
            },
        },
        {
            field: 'dossierId',
            title: i18n.t('Réf.Dossier'),
            render: rowData => {
                return (
                    <Button
                        onClick={() => navigate(`/${role}/dossier/${rowData?._id}`)}
                    >
                        {rowData?.dossierId}
                    </Button>);
            }
        },
        {
            field: 'nomDossier',
            title: i18n.t('Nom du dossier'),
        },
        {
            field: 'statut',
            title: i18n.t('Statut'),
            render: rowData => (
                <>
                    {i18n.t(searchLabelInEnumByValue(StatutDosier, rowData?.statut))}
                </>
            )
        },
        {
            field: 'nbCandidatures',
            title: i18n.t('Nb.de CV'),
        },
        {
            field: 'countInterviewed',
            title: i18n.t('Candidatures "à interviewer"'),
        },
        {
            field: 'countRetained',
            title: i18n.t('Candidatures "Retenues"'),
            // * in case it couldn't get the value at time:
            //  render: rowData => (
            //     <>
            //         {countCandidatureByStatus(rowData?.candidatures)?.countRetained}
            //     </>
            // )
        },
        {
            field: 'dateDebutMission',
            title: i18n.t('Date début Mission'),
            render: rowData => (
                <>
                    {formatDateJJMMYYYY(rowData?.dateDebutMission)}
                </>
            )
        },
        {
            field: 'dateDebutMission',
            title: i18n.t('Date fin Mission'),
            render: rowData => (
                <>
                    {formatDateJJMMYYYY(rowData?.dateFinMission)}
                </>
            )
        },
        {
            field: 'localisation',
            title: i18n.t('Localisation'),
        },
        {
            field: 'dureeBDC',
            title: i18n.t('Durée du BDC'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.dureeBDC,'mois');
            }
        },
        {
            field: 'tjMax',
            title: i18n.t('Budget Max/j'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.tjMax);
            }
        },
        {
            field: 'createur',
            title: i18n.t('Créé par'),
        },
        {
            field: 'dateCreation',
            title: i18n.t('Date création dossier'),
        },
    ];
    const [openClasser, setOpenClasser] = useState(false);
    const [dossierList, setDossierList] = useState([]);
    const { data: dossiers, refresh } = useGetRequest({ url: '/cvTheque/getAllMyDossiers' });
    const [selectedDossiers, setSelectedDossiers] = useState([]);
    const [selectedDossier, setSelectedDossier] = useState();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [filtre, setFiltre] = useState(searchParams.get('filtre') === 'true');
    const [filtreCandidatInterview, setFiltreCandidatInterview] = useState(searchParams.get('filtreCandidatInterview') === 'true');
    const [filtreCandidatUnread, setFiltreCandidatUnread] = useState(searchParams.get('filtreCandidatUnread') === 'true');
    const [url, setUrl] = useState('');
    const {device}=useWindowSize();
    const { postData } = usePostRequest();
    const navigate = useNavigate();

    useEffect(() => {
        const currentUrl = window.location.href;
        setUrl(currentUrl);
    }, [location]);

    useEffect(() => {
        if(url && !url.toLowerCase().includes('filtre') && !url.toLowerCase().includes('filtrecandidatunread') && !url.toLowerCase().includes('filtrecandidatinterview') ){
            setFiltre(false);
            setFiltreCandidatUnread(false);
            setFiltreCandidatInterview(false);
        }
    }, [url]);

    useEffect(() => {
        refresh();
    }, [filtre,filtreCandidatInterview,filtreCandidatUnread]);

    const mapDossier = (dossier) => {
        return {
            'dossierId': dossier?.dossierId,
            'nomDossier': dossier?.nom,
            //statut d'un dossier cloture ou en cours faut ajouter un btn cloturer dans mes dossier
            'statut': dossier?.statut,
            'nbCandidatures': dossier?.candidatures?.length,
            'countInterviewed': countCandidatureByStatus(dossier?.candidatures)?.countInterviewed,
            'countRetained': countCandidatureByStatus(dossier?.candidatures)?.countRetained,
            //à faire by reda
            'localisation': dossier?.localisation,
            'tjMax': dossier?.tjMax,
            'dateCreation': formatDateJJMMYYYY(dossier?.createdAt),
            'dateDebutMission': formatDateJJMMYYYY(dossier?.dateDebutMission),
            'dureeBDC': dossier?.dureeBDC,
            'budgetMax': dossier?.tjMax ? dossier?.tjMax+ ' €' :'Non précisé',
            'createur': getNomPrenomClearFromPersoData(dossier?.collaboratorId?.persoData ?? dossier?.collaboratorEsnId?.persoData),
            ...dossier,
        };
    };
    useEffect(() => {
        if (dossiers) {
            let tempArr = [];
            let temp_interviewed=0;
            let temp_unread=0;
            if(filtre==true){
                dossiers?.reverse().forEach(dossier => {
                    if(dossier?.statut=='encours'){
                        tempArr.push(mapDossier(dossier));
                    }
                });
            }
            else if(filtreCandidatInterview==true){
                dossiers?.reverse().forEach(dossier => {
                    temp_interviewed=countCandidatureByStatus(dossier?.candidatures)?.countInterviewed;
                    if(dossier?.statut=='encours' && temp_interviewed>0){
                        tempArr.push(mapDossier(dossier));
                    }
                });
            }
            else if (filtreCandidatUnread==true){
                dossiers?.reverse().forEach(dossier => {
                    temp_unread=countCandidatureByStatus(dossier?.candidatures)?.countUnread;
                    console.log('temp_unread',temp_unread);
                    if(dossier?.statut=='encours' && temp_unread>0){
                        tempArr.push(mapDossier(dossier));
                    }
                });
            }
            else{
                dossiers?.reverse().forEach(dossier => {
                    tempArr.push(mapDossier(dossier));
                });
            }
            setDossierList(tempArr);
        }
    }, [dossiers]);
    const cloturerDossiers = async () => {
        if (selectedDossiers.length > 0) {
            await postData({ url: '/cvTheque/cloturerDossiers', payload: { dossierIds: selectedDossiers.map((dossier) => dossier?._id) } })
                .then(() => {
                    refresh();
                    setSelectedDossiers([]);
                }).catch((err) => console.log(err));
        }
    };
    const [selectedRow, setSelectedRow] = React.useState(null);
    return (
        <>

            <div className='frame5Profile'>
                {i18n.t('CVThèque')} &gt;  <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{ i18n.t('Mes dossiers')}</span>
            </div>
            <div className='HomeFrame'>
                <h4 className='titlesociete'>
                    {i18n.t('Mes dossiers')}
                </h4>
                <div style={{ justifyContent: 'flex-end', alignSelf: 'stretch', display: 'flex' }}>
                    <Button
                        variant="contained"
                        style={{ ...buttonStylesGreen((selectedDossiers.length>0 ? false:true)),...{width:device=='desktop'?'auto':'100%'} }}
                        onClick={cloturerDossiers}
                    > {i18n.t('Clôturer le dossier')}
                    </Button>
                </div>

                <MaterialTableComponent
                    columns={columns}
                    data={dossierList}
                    title={i18n.t('DossierList et BDC')}
                    onRowClick={(event, rowData) => {
                        // navigate(`/client/dossier/${rowData?._id}`);
                        setSelectedRow(rowData?.tableData.id);
                    }}
                    selectedRow={selectedRow}
                    options={{
                        selection: true
                    }}
                    localization={{
                        body: {
                            deleteTooltip: 'Supprimer',
                            editTooltip: 'Editer',
                            editRow: { deleteText: 'Etes-vous sûr de vouloir supprimer ce dossier?', }
                        }
                    }}
                    onSelectionChange={(rows) => {
                        setSelectedDossiers(rows);
                    }}
                    editable={{
                    //onRowAdd: newData =>
                        //    new Promise((resolve) => {
                        //        setTimeout(() => {
                        //            console.log({ newData });
                        //            // setData([...data, newData]);
                        //            resolve();
                        //        }, 1000);
                        //    }),

                        //onRowUpdate: (newData, oldData) =>
                        //    new Promise((resolve) => {
                        //        setTimeout(() => {
                        //            // const dataUpdate = [...data];
                        //            // const index = oldData.tableData.id;
                        //            // dataUpdate[index] = newData;
                        //            // setData([...dataUpdate]);
                        //            console.log({ newData, oldData });
                        //            resolve();
                        //        }, 1000);
                        //    }),
                        onRowDelete: oldData =>
                            new Promise((resolve) => {
                                postData({ url: `/cvTheque/deleteDossier/${oldData?._id}` })
                                    .then(() => refresh());
                                setTimeout(() => {
                                    // const dataDelete = [...data];
                                    // const index = oldData.tableData.id;
                                    // dataDelete.splice(index, 1);
                                    // setData([...dataDelete]);
                                    console.log({ oldData });
                                }, 1000);
                                resolve();
                            }),
                    }}
                />
                {openClasser &&
                    <DialogModifierDossier
                        selectedDossier={selectedDossier}
                        openClasser={openClasser}
                        handleCloseClasser={() => {
                            setOpenClasser(false);
                            refresh();
                        }}
                    />}
            </div>
        </>
    );
};

export default AllMyDossier;